var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group form-group--file", class: _vm.getClass() },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { class: `col-sm-${_vm.component.size}` }, [
          _c("label", [
            _vm._v(_vm._s(_vm.component.label) + "\n        "),
            _vm.isRequired()
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
          ]),
          _vm.component.data
            ? _c("div", { staticClass: "dropzone" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.component.data.currentValue,
                      expression: "component.data.currentValue",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.setRules(),
                      expression: "setRules()",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    "data-vv-name": _vm.component.key,
                    name: _vm.component.key,
                    type: "hidden",
                  },
                  domProps: { value: _vm.component.data.currentValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.component.data,
                        "currentValue",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    attrs: {
                      id: `file-input-${_vm.component.key}`,
                      disabled: _vm.disabledHandler(),
                      type: "button",
                    },
                  },
                  [_vm._v("Selecionar arquivos...\n        ")]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.dropzone.files.length,
                        expression: "dropzone.files.length",
                      },
                    ],
                    staticClass: "container-fluid dropzone-table",
                    attrs: { id: `dropzone-${_vm.component.key}` },
                  },
                  [_vm._m(0)]
                ),
              ])
            : _vm._e(),
          _vm.errors.has(_vm.component.key)
            ? _c("span", { staticClass: "help-block help-block--bottom" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 14 14",
                      width: "14",
                    },
                  },
                  [
                    _c("g", { attrs: { transform: "translate(-252 -635)" } }, [
                      _c("rect", {
                        staticClass: "cls-1",
                        attrs: {
                          width: "14",
                          height: "14",
                          transform: "translate(252 635)",
                        },
                      }),
                      _c("path", {
                        staticClass: "cls-2",
                        attrs: {
                          d: "M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z",
                          transform: "translate(251 634)",
                        },
                      }),
                    ]),
                  ]
                ),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.errors.first(_vm.component.key)) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          !_vm.errors.has(_vm.component.key) && _vm.component.description
            ? _c("span", { staticClass: "help-block help-block--bottom" }, [
                _vm._v(_vm._s(_vm.component.description)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row thead" }, [
      _c("div", { staticClass: "col-6 col-md-4" }, [_vm._v("Nome do Arquivo")]),
      _c("div", { staticClass: "hidden-xs col-md-1" }, [_vm._v("Tamanho")]),
      _c("div", { staticClass: "col-2 col-md-1" }, [_vm._v("Status")]),
      _c("div", { staticClass: "col-3 col-md-5" }, [_vm._v("Progresso")]),
      _c("div", { staticClass: "col-1" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }